module.exports = __webpack_public_path__ + "static/media/dcmadded.6279a75f.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/public/userarea/dcmadded.png
// module id = 295
// module chunks = 0